import lazyLoad from "./lazyLoader";
import collection from '../modules/collectionGrid';

interface IAdvertisements {
  btn_text: string[],
  btn_url: string[],
  heading: string[],
  img_mobile: [][],
  img_desktop: [][],
  position: string[],
  [key: string]:any
}

interface ISortedAdvertisement {
  btn_text: string,
  btn_url: string,
  heading: string,
  img_mobile: accentuateImg[],
  img_desktop: accentuateImg[],
  position: number,
  [key: string]:any
}

interface accentuateImg {
  src: string
}

interface IAdvertisementsConfig {
  currentPage: number
}

class Advertisements {

  private sortedAdvertisements:ISortedAdvertisement[];
  private config: IAdvertisementsConfig;

  constructor() {
    this.config = {
      currentPage: 1
    }
    this.sortedAdvertisements = null;
  }

  public init(advertisements:IAdvertisements, currentPage:number) {
    this.load(advertisements, currentPage);
  }

  public load(advertisements:IAdvertisements, currentPage:number) {
    if (advertisements) {
      this.sortedAdvertisements = this.sort(this.reduce(advertisements));
      this.update(currentPage);
    }
  }

  private reduce(advertisements:IAdvertisements) {
    return Object.keys(advertisements).reduce((acc:ISortedAdvertisement[], key, index) => {
      advertisements[key].forEach((value:any, index:number) => {
        acc[index] = acc[index] || this.createEmptyAdvertisement();
        if (key == 'position') value = parseInt(value);
        acc[index][key] = value || null;
      });
      return acc;
    }, []);
  }

  private createEmptyAdvertisement() {
    return {
      btn_text: null,
      btn_url: null,
      position: null,
      img_mobile: null,
      img_desktop:null,
      heading: null,
      currentPage: 1,
    } as ISortedAdvertisement;
  }

  private sort(reducedAdvertisements:ISortedAdvertisement[]) {
    return reducedAdvertisements.sort((a:ISortedAdvertisement, b:ISortedAdvertisement) => (a.position > b.position) ? 1 : -1);
  }

  public update(currentPage: number) {
    this.sortedAdvertisements.filter((advertisement) => {
      return advertisement.position <= collection.config.productsPerPage * currentPage;
    }).forEach(advertisement => {
      const collectionTiles = document.querySelectorAll('[data-product-tile], [data-advertisement]');
      this.render(advertisement, collectionTiles);
      this.sortedAdvertisements.shift();
      this.config.currentPage++;
      lazyLoad.update();
    });
  }

  private render(advertisement:ISortedAdvertisement, collectionTiles:NodeList) {
    const imgMobileSrc = advertisement.img_mobile ? advertisement.img_mobile[0].src : null;
    const imgDesktopSrc = advertisement.img_desktop ? advertisement.img_desktop[0].src : null;
    const collectionTile = collectionTiles[advertisement.position - 1] as HTMLElement;

    if (collectionTile && imgMobileSrc && imgDesktopSrc) {
      collectionTile.insertAdjacentHTML('beforebegin', `
        <div class="hero hero--advertisement" data-advertisement>
          <div class="hero__imgs">
            <div class="hide--sm">
              <img class="img lazy" data-src="${ imgDesktopSrc }">
            </div>
            <div class="hide--md-up">
              <img class="img lazy" data-src="${ imgMobileSrc }">
            </div>
          </div>
          <div class="hero__bottom">
            <div class="cta cta--invert">
              <h2 class="cta__heading cta__heading--h2">
                ${ advertisement.heading }
              </h2>
              <div class="cta__btns">
                <a class="btn btn--invert btn--squeeze" href="${ advertisement.btn_url }">
                  ${ advertisement.btn_text }
                </a>
              </div>
            </div>
          </div>
        </div>
      `);
    }
  }
}

export default new Advertisements();